import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_DETAIL_PREFIX_URL } from './constants/config.document-detail'

const ListDynamic = lazy(() => import('./pages/List.Dynamic.DocumentDetail'))
const EditPage = lazy(() => import('./pages/EditPage.DocumentDetail'))
const ViewPage = lazy(() => import('./pages/ViewPage.DocumentDetail'))

const listRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/my-created`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="my-created"
          showCreate
          listName="Danh sách phiên bản tài liệu tôi tạo"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/approved-by-me`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="approved-by-me"
          listName="Danh sách phiên bản tài liệu tôi đã duyệt"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/waiting-me-approve`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="waiting-me-approve"
          listName="Danh sách phiên bản tài liệu chờ tôi duyệt"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/me`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="me"
          showCreate
          listName="Danh sách phiên bản tài liệu tôi có quyền xem"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/my-draft`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="my-created"
          defaultFilter={{ approvalStatus: ['DRAFT'] }}
          listName="Danh sách phiên bản tài liệu bản nháp"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/my-submitting`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="my-created"
          defaultFilter={{ approvalStatus: ['SUBMITTING'] }}
          listName="Danh sách phiên bản tài liệu đang trình duyệt"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/my-editing`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="my-created"
          defaultFilter={{ approvalStatus: ['EDITING'] }}
          listName="Danh sách phiên bản tài liệu đang chỉnh sửa"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/my-approved`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="my-created"
          defaultFilter={{ approvalStatus: ['APPROVED'] }}
          listName="Danh sách phiên bản tài liệu đã được duyệt"
        />
      </LoadingLazyComponents>
    ),
  },
  {
    path: `${DOCUMENT_DETAIL_PREFIX_URL}/my-rejected`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListDynamic
          listVariant="my-created"
          defaultFilter={{ approvalStatus: ['REJECTED'] }}
          listName="Danh sách phiên bản tài liệu bị từ chối duyệt"
        />
      </LoadingLazyComponents>
    ),
  },
]

// Nested route detail trong route các list
const detailRouters: AppRouterItem[] = listRouters.flatMap(
  ({ path: listPath }) => [
    {
      path: `${listPath}/:documentDetailId/edit`,
      element: (
        <LoadingLazyComponents loadingType="skeleton">
          <EditPage />
        </LoadingLazyComponents>
      ),
    },
    {
      path: `${listPath}/:documentDetailId/view`,
      element: (
        <LoadingLazyComponents loadingType="skeleton">
          <ViewPage />
        </LoadingLazyComponents>
      ),
    },
    {
      path: `${listPath}/:documentDetailId`,
      element: (
        <LoadingLazyComponents loadingType="skeleton">
          <ViewPage />
        </LoadingLazyComponents>
      ),
    },
  ]
)

const DocumentDetailRouters: AppRouterItem[] = [
  ...listRouters,
  ...detailRouters,
]

export default DocumentDetailRouters
